export enum HttpStatusCode {
  OK = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  InternalServerError = 500,
}

export interface Agent {
  avatarUrl: string;
}

export interface Agency {
  customerId: string;
  customerName: string;
  profilePageUrlKeyword: string;
  saleCount?: number;
  logo: string;
  city?: string;
  postalCode?: string;
  agents: Agent[];
  propertiesForRentCount: number;
  propertiesForBuyCount: number;
  descriptions?: { [key: string]: string };
}

export enum ListingType {
  ANY = 'ANY',
  RENT = 'RENT',
  SALE = 'SALE',
}

export enum ListingTypeForTracking {
  ANY = 'any',
  RENT = 'rent',
  SALE = 'buy',
}

export enum SortingOption {
  DEFAULT = 'completeness_score',
  ALPHABETICALLY = 'customer_name',
  PROPERTIES_FOR_RENT = 'for_rent_high',
  PROPERTIES_FOR_SALE = 'for_buy_high',
}
